export type PhotoSection = "cover" | "packshot";
export type DirectionCode = "F" | "B" | "L" | "R" | "T" | "BT" | "SP" | "O";
export type ParseState = "confident" | "unknown";

export interface FileWithPath extends File {
  path?: string;
}

export interface DirectionDef {
  code: DirectionCode;
  angle: string; // maps to ProductLibFile packshot angle vocabulary
  label: string; // Thai/EN label for the chooser
}

// One source of truth for direction codes. Extend here to add angles.
export const DIRECTIONS: DirectionDef[] = [
  { code: "F", angle: "FRONT", label: "Front" },
  { code: "B", angle: "BACK", label: "Back" },
  { code: "L", angle: "LEFT", label: "Left" },
  { code: "R", angle: "RIGHT", label: "Right" },
  { code: "T", angle: "TOP", label: "Top" },
  { code: "BT", angle: "BOTTOM", label: "Bottom" },
  { code: "SP", angle: "SHINK_PAPER", label: "Shrink paper" },
  { code: "O", angle: "OTHER", label: "Other" },
];

export const SECTIONS: PhotoSection[] = ["cover", "packshot"];

const DIRECTION_CODES = new Set<string>(DIRECTIONS.map((d) => d.code));
export function isDirectionCode(x: string): x is DirectionCode {
  return DIRECTION_CODES.has(x);
}

export interface PhotoDraft {
  id: string;
  file: FileWithPath;
  previewUrl: string;
  ext: string;
  barcode: string;
  matCode: string;
  section: PhotoSection;
  direction: DirectionCode | null;
  order: number;
  isMain: boolean;
  origin: { section?: PhotoSection; direction?: DirectionCode | null; fileName: string };
  parseState: ParseState;
}

/** Stable key that identifies one product (a barcode + matcode pair). */
export function productKeyOf(barcode: string, matCode: string): string {
  return `${barcode}/${matCode}`;
}
